<template>
    <div
        class="dropdown"
        :class="{ 'is-active' : active, 'is-right' : rightAligned }"
        @click="toggle"
        ref="dropdown"
    >

        <div class="dropdown-trigger">
            <button class="button" :class="clazz" aria-haspopup="true" aria-controls="dropdown-menu" >
                <span>
                    <slot name="selection">
                    </slot>
                </span>
                <span class="icon is-small">
                    <i class="m-r-xs m-l-xs" :class="active ? icons.active_class : icons.inactive_class" aria-hidden="true"></i>
                </span>
            </button>
        </div>

        <div class="dropdown-menu" id="dropdown-menu" role="menu">
            <div class="dropdown-content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name : 'DropdownSelectionSlotted',
    data () {
        return {
            active : false,
        };
    },
    props : {
        clazz : {
            type : String,
            required : false,
            default : ''
        },
        rightAligned : {
            type : Boolean,
            default : false,
        },
    },
    computed : {
        icons(){
            return {
                active_class : 'fa fa-angle-up',
                inactive_class : 'fa fa-angle-down'
            }
        },
    },
    methods : {
        toggle () {
            if(!this.active){
                this.active = true;
                window.addEventListener('click', this.close, { passive : true })
            } else {
                this.active = false;
                window.removeEventListener('click', this.close);
            }
        },
        close (event) {
            if(!this.$refs.dropdown.contains(event.target)){
                this.active = false;
                window.removeEventListener('click', this.close);
            }
        },
    },
};
</script>

<style scoped lang="scss">
    .dropdown-content {
        a.dropdown-item {
            padding-right:1rem;
        }
    }
</style>
